var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ZipService } from './zip.service';
import { ItemBase } from '../../../models/item/item-base';
var ZipComponent = /** @class */ (function (_super) {
    __extends(ZipComponent, _super);
    function ZipComponent(service, baseService, zipService, cdRef) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.zipService = zipService;
        _this.cdRef = cdRef;
        _this.mapKey = [];
        _this.selectCol = new ItemBase();
        return _this;
    }
    ZipComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.mapKey = this.col.params && this.col.params.map ? this.col.params.map : [];
    };
    ZipComponent.prototype.onChangeVal = function (e1, e2) {
        if (e2 === 'zip') {
            _super.prototype.onChange.call(this, e1);
            this.getPost(e1);
        }
        else if (e2 === 'select' && e1) {
            var rec = jsonpath.value(this.selectCol, '$.params.options[?(@.code==' + e1 + ')]');
            _super.prototype.onChange.call(this, rec.data.zip_new);
            this.setValue(rec.data);
        }
    };
    ZipComponent.prototype.getPost = function (zip) {
        var _this = this;
        if (zip.length !== 7) {
            return;
        }
        this.zipService.getPost(zip).subscribe(function (rec) {
            _this.selectCol = new ItemBase();
            if (rec instanceof Array) {
                if (rec.length === 1) {
                    _this.setValue(rec[0]);
                }
                else if (rec.length > 1) {
                    var options = [];
                    for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                        var r = rec_1[_i];
                        options.push({
                            code: r.post_id,
                            display: r.zip_new.substr(0, 3) + '-' + r.zip_new.substr(3) + ' ' + r.prefecture + ' ' + r.city + ' ' + r.town,
                            data: r
                        });
                    }
                    _this.selectCol = Object.assign(new ItemBase(), {
                        key: 'select_zip',
                        controlType: 'select',
                        params: {
                            options: options
                        }
                    });
                }
            }
            _this.cdRef.detectChanges();
        });
    };
    ZipComponent.prototype.setValue = function (rec) {
        var data = {};
        for (var _i = 0, _a = this.mapKey; _i < _a.length; _i++) {
            var mk = _a[_i];
            var val = rec[mk.key] || '';
            if (!data[mk.target]) {
                data[mk.target] = '';
            }
            data[mk.target] += val;
        }
        var _loop_1 = function (key) {
            var select = $('select[name="' + this_1.baseService.getColKey(this_1.componentName, key, this_1.index) + '"]');
            if (select.length) {
                var val = $('select[name="' + this_1.baseService.getColKey(this_1.componentName, key, this_1.index) + '"] option').filter(function (index) {
                    return $(this).text() === data[key];
                }).val();
                this_1.changeVal.emit({ key: key, val: val });
            }
            else {
                this_1.changeVal.emit({ key: key, val: data[key] });
            }
        };
        var this_1 = this;
        for (var key in data) {
            _loop_1(key);
        }
    };
    ZipComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-zip',
                    template: "<dl class=\"form\">\n  <dt></dt>\n  <dd class=\"form_dd\">\n    <ul>\n      <li class=\"form_li form_li-w100\">\n        <column-text [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event.val, 'zip')\"></column-text>\n      </li>\n      <ng-template [ngIf]=\"selectCol.params?.options\">\n        <li class=\"form_li form_li-break\"></li>\n        <li class=\"form_li -mt-05\">\n          <column-select [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"selectCol\" [val]=\"''\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event.val, 'select')\"></column-select>\n        </li>\n      </ng-template>\n    </ul>\n  </dd>\n</dl>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    ZipComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ZipService },
        { type: ChangeDetectorRef }
    ]; };
    return ZipComponent;
}(ColumnBaseComponent));
export { ZipComponent };
//# sourceMappingURL=zip.component.js.map